import axios from "../utils/request"
import path from "./path"

axios.defaults.timeout = 30000

const api = {
    timestampToTime(timestamp) {  
        var date = new Date(timestamp);    
        var year = date.getFullYear();  
        var month = String(date.getMonth() + 1).padStart(2, '0'); 
        var day = String(date.getDate()).padStart(2, '0');  
        var hours = String(date.getHours()).padStart(2, '0'); 
        var minutes = String(date.getMinutes()).padStart(2, '0');  
        var seconds = String(date.getSeconds()).padStart(2, '0');  
        
        var dateTimeString = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;  
        
        return dateTimeString;  
    },

    sub50(content){
        if (!content) return '';  
        return content.length > 50 ? content.substring(0, 50) + '...' : content;
    },

    login(data){
        return axios.post(path.login, data)
    },
    getBottleCount(search){
        return axios.post(path.getBottleCount, search)
    },
    getBottle(pageInfo){
        return axios.post(path.getBottle, pageInfo)
    },
    deleteBottle(id){
        return axios.post(path.deleteBottle, id)
    },

    getDiaryCount(search){
        return axios.post(path.getDiaryCount, search)
    },
    getDiary(pageInfo){
        return axios.post(path.getDiary, pageInfo)
    },
    deleteDiary(id){
        return axios.post(path.deleteDiary, id)
    },
    pushDiary(id){
        return axios.post(path.pushDiary, id)
    },
    rejectDiary(id){
        return axios.post(path.rejectDiary, id)
    },
    getDiaryCommentCount(search){
        return axios.post(path.getDiaryCommentCount, search)
    },
    getDiaryComment(pageInfo){
        return axios.post(path.getDiaryComment, pageInfo)
    },
    deleteDiaryComment(id){
        return axios.post(path.deleteDiaryComment, id)
    },

    getMovieCount(search){
        return axios.post(path.getMovieCount, search)
    },
    getMovie(pageInfo){
        return axios.post(path.getMovie, pageInfo)
    },
    deleteMovie(id){
        return axios.post(path.deleteMovie, id)
    },
    addMovie(movie){
        return axios.post(path.addMovie, movie)
    },
    uploadMovieImage(file){
        return axios.post(path.uploadMovieImage, file)
    },
    updateMovie(movie){
        return axios.post(path.updateMovie, movie)
    },
    pushMovie(id){
        return axios.post(path.pushMovie, id)
    },
    rejectMovie(id){
        return axios.post(path.rejectMovie, id)
    },
    getMovieCommentCount(search){
        return axios.post(path.getMovieCommentCount, search)
    },
    getMovieComment(pageInfo){
        return axios.post(path.getMovieComment, pageInfo)
    },
    deleteMovieComment(id){
        return axios.post(path.deleteMovieComment, id)
    },

    getMusicCount(search){
        return axios.post(path.getMusicCount, search)
    },
    getMusic(pageInfo){
        return axios.post(path.getMusic, pageInfo)
    },
    deleteMusic(id){
        return axios.post(path.deleteMusic, id)
    },
    addMusic(music){
        return axios.post(path.addMusic, music)
    },
    uploadMusicImage(file){
        return axios.post(path.uploadMusicImage, file)
    },
    updateMusic(music){
        return axios.post(path.updateMusic, music)
    },
    pushMusic(id){
        return axios.post(path.pushMusic, id)
    },
    rejectMusic(id){
        return axios.post(path.rejectMusic, id)
    },
    uploadMusic(file){
        return axios.post(path.uploadMusic, file)
    },

    getBookCount(search){
        return axios.post(path.getBookCount, search)
    },
    getBook(pageInfo){
        return axios.post(path.getBook, pageInfo)
    },
    deleteBook(id){
        return axios.post(path.deleteBook, id)
    },
    addBook(book){
        return axios.post(path.addBook, book)
    },
    uploadBookImage(file){
        return axios.post(path.uploadBookImage, file)
    },
    updateBook(book){
        return axios.post(path.updateBook, book)
    },
    pushBook(id){
        return axios.post(path.pushBook, id)
    },
    rejectBook(id){
        return axios.post(path.rejectBook, id)
    },
    getBookCommentCount(search){
        return axios.post(path.getBookCommentCount, search)
    },
    getBookComment(pageInfo){
        return axios.post(path.getBookComment, pageInfo)
    },
    deleteBookComment(id){
        return axios.post(path.deleteBookComment, id)
    },

    getQuestionaryCount(search){
        return axios.post(path.getQuestionaryCount, search)
    },
    getQuestionary(pageInfo){
        return axios.post(path.getQuestionary, pageInfo)
    },
    deleteQuestionary(id){
        return axios.post(path.deleteQuestionary, id)
    },
    addQuestionary(questionary){
        return axios.post(path.addQuestionary, questionary)
    },
    addQuestionaryResult(questionary){
        return axios.post(path.addQuestionaryResult, questionary)
    },
    getQuestion(questionaryID){
        return axios.post(path.getQuestion, questionaryID)
    },
    getQuestionaryResult(questionaryInfo){
        return axios.post(path.getQuestionaryResult, questionaryInfo)
    },
    getQuestionaryDetail(questionaryInfo){
        return axios.post(path.getQuestionaryDetail, questionaryInfo)
    },
    updateQuestionary(questionary){
        return axios.post(path.updateQuestionary, questionary)
    },
    addQuestionaryCode(questionary){
        return axios.post(path.addQuestionaryCode, questionary)
    },
    getQuestionaryRecord(info){
        return axios.post(path.getQuestionaryRecord, info)
    },
    getTestUserCount(search){
        return axios.post(path.getTestUserCount, search)
    },
    getTestUser(search){
        return axios.post(path.getTestUser, search)
    },
    getUserTestResult(id){
        return axios.post(path.getUserTestResult, id)
    },

    getArticleCount(info){
        return axios.post(path.getArticleCount, info)
    },
    getArticle(pageInfo){
        return axios.post(path.getArticle, pageInfo)
    },
    pushArticle(id){
        return axios.post(path.pushArticle, id)
    },
    rejectArticle(id){
        return axios.post(path.rejectArticle, id)
    },
    addArticle(id){
        return axios.post(path.addArticle, id)
    },
    uploadArticleImage(id){
        return axios.post(path.uploadArticleImage, id)
    },
    deleteArticle(article){
        return axios.post(path.deleteArticle, article)
    },
    uploadArticleAudio(id){
        return axios.post(path.uploadArticleAudio, id)
    },
    getArticleCommentCount(info){
        return axios.post(path.getArticleCommentCount, info)
    },
    getArticleComment(pageInfo){
        return axios.post(path.getArticleComment, pageInfo)
    },
    deleteArticleComment(comment){
        return axios.post(path.deleteArticleComment, comment)
    },

    getCourseCount(search){
        return axios.post(path.getCourseCount, search)
    },
    getCourse(pageInfo){
        return axios.post(path.getCourse, pageInfo)
    },
    deleteCourse(id){
        return axios.post(path.deleteCourse, id)
    },
    addCourse(course){
        return axios.post(path.addCourse, course)
    },
    uploadCourseImage(file){
        return axios.post(path.uploadCourseImage, file)
    },
    uploadCourseVideo(file){
        return axios.post(path.uploadCourseVideo, file)
    },
    updateCourse(course){
        return axios.post(path.updateCourse, course)
    },

    getPopularizationCount(search){
        return axios.post(path.getPopularizationCount, search)
    },
    getPopularization(pageInfo){
        return axios.post(path.getPopularization, pageInfo)
    },
    deletePopularization(id){
        return axios.post(path.deletePopularization, id)
    },
    addPopularization(popularization){
        return axios.post(path.addPopularization, popularization)
    },
    uploadPopularizationImage(file){
        return axios.post(path.uploadPopularizationImage, file)
    },
    updatePopularization(popularization){
        return axios.post(path.updatePopularization, popularization)
    },
    uploadPopularizationAudio(file){
        return axios.post(path.uploadPopularizationAudio, file)
    },
    getPopularizationCommentCount(search){
        return axios.post(path.getPopularizationCommentCount, search)
    },
    getPopularizationComment(pageInfo){
        return axios.post(path.getPopularizationComment, pageInfo)
    },
    deletePopularizationComment(id){
        return axios.post(path.deletePopularizationComment, id)
    },

    getSchoolCount(search){
        return axios.post(path.getSchoolCount, search)
    },
    getSchool(pageInfo){
        return axios.post(path.getSchool, pageInfo)
    },
    addSchool(school){
        return axios.post(path.addSchool, school)
    },
    deleteSchool(id){
        return axios.post(path.deleteSchool, id)
    },
    updateSchool(school){
        return axios.post(path.updateSchool, school)
    },

    getClassCount(search){
        return axios.post(path.getClassCount, search)
    },
    getClass(pageInfo){
        return axios.post(path.getClass, pageInfo)
    },
    addClass(classInfo){
        return axios.post(path.addClass, classInfo)
    },
    deleteClass(id){
        return axios.post(path.deleteClass, id)
    },
    updateClass(classInfo){
        return axios.post(path.updateClass, classInfo)
    },

    getUserCount(search){
        return axios.post(path.getUserCount, search)
    },
    getUser(pageInfo){
        return axios.post(path.getUser, pageInfo)
    },
    changeUserRole(info){
        return axios.post(path.changeUserRole, info)
    },

    getAdminCount(search){
        return axios.post(path.getAdminCount, search)
    },
    getAdmin(pageInfo){
        return axios.post(path.getAdmin, pageInfo)
    },
    changeMemberInfo(info){
        return axios.post(path.changeMemberInfo, info)
    },
    changePassword(info){
        return axios.post(path.changePassword, info)
    },
    getAdminPassword(id){
        return axios.post(path.getAdminPassword, id)
    },
    addMember(info){
        return axios.post(path.addMember, info)
    },
    getMemberInfo(id){
        return axios.post(path.getMemberInfo, id)
    },
    deleteMember(id){
        return axios.post(path.deleteMember, id)
    },
    resetPassword(id){
        return axios.post(path.resetPassword, id)
    },
    updateMember(info){
        return axios.post(path.updateMember, info)
    },

    getRecommendCount(info){
        return axios.post(path.getRecommendCount, info)
    },
    getRecommend(pageInfo){
        return axios.post(path.getRecommend, pageInfo)
    },
    deleteRecommend(id){
        return axios.post(path.deleteRecommend, id)
    },
    handleRecommend(id){
        return axios.post(path.handleRecommend, id)
    },
    revokeRecommend(id){
        return axios.post(path.revokeRecommend, id)
    },

    getStudentCount(){
        return axios.post(path.getStudentCount)
    },
    getTypeCount(source){
        return axios.post(path.getTypeCount, source)
    },
    getOpinionCount(info){
        return axios.post(path.getOpinionCount, info)
    },
    getOpinion(pageInfo){
        return axios.post(path.getOpinion, pageInfo)
    },
    getAllOpinion(){
        return axios.post(path.getAllOpinion)
    },
    getReportCount(){
        return axios.post(path.getReportCount)
    },
    getReport(pageInfo){
        return axios.post(path.getReport, pageInfo)
    },
    handleReport(id){
        return axios.post(path.handleReport, id)
    },
    revokeReport(id){
        return axios.post(path.revokeReport, id)
    },

    addLoginRecord(info){
        return axios.post(path.addLoginRecord, info)
    },

    getLoginRecordCount(search){
        return axios.post(path.getLoginRecordCount, search)
    },
    getLoginRecord(pageInfo){
        return axios.post(path.getLoginRecord, pageInfo)
    },
}

export default api